export default class Acc {
    constructor() {
        this.$accs = [...document.querySelectorAll('.js-acc')];
    }

    eventBind() {
        for (const $acc of this.$accs) {
            const $toggle = $acc.querySelector('.js-acc_toggle');
            const $cont = $acc.querySelector('.js-acc_cont');

            this.changeHeight($acc, $cont);

            $toggle.addEventListener('click', () => {
                $acc.classList.toggle('-active');
                this.changeHeight($acc, $cont);
            });
        }
    }

    changeHeight($acc, $cont) {
        const $box = $acc.closest('.js-tab_box');

        if ($box && !$box.classList.contains('-select')) return;

        $cont.style.height = $acc.classList.contains('-active') ? `${$cont.scrollHeight}px` : 0;
    }
}
